import { addBehaviorstats } from '../model/jimu'
import { getPageParamSession } from '../utils/session/tour'


/**
 * 添加行为统计
 */
export function addBehaviorsRecord({ object = 150000, behaviorType, behavior, value1, value2, value3, value4 }) {
    const { room = '', partner = '', member = '', hotel = '' } = getPageParamSession() || {}
    const hotelName = hotel? decodeURIComponent(hotel):''
    
    addBehaviorstats({
        object,
        behaviorType,
        behavior,
        value1: value1 || `${hotelName}-${room}`,
        value2,
        value3: value3 || member || '',
        value4
    }).then(data => {
        console.log(data)
    }).catch(ex => {
        console.log(ex)
    })

}